import { Directive } from '@angular/core';

/**
 * Button Action Directive
 *
 * Adds action button styling to PrimeNG buttons.
 * Use with p-button to create actionable icon buttons.
 *
 * @example
 * <p-button pButtonAction icon="pi pi-plus" label="Add" />
 *
 * @usageNotes
 * The directive uses attribute selector styling - no class manipulation needed.
 * Styles are applied via [pButtonAction] CSS selector in the preset.
 */
@Directive({
  selector: 'p-button[pButtonAction], button[pButton][pButtonAction], a[pButton][pButtonAction]',
  standalone: true,
})
export class ButtonActionDirective {}
